var _circle, _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleLimeError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#E3FB94"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-circle-lime--error_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M4.801 4.799h18.4v18.4h-18.4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-circle-lime--error_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 18.48a.74.74 0 00.545-.22.74.74 0 00.22-.544.74.74 0 00-.22-.546.74.74 0 00-.545-.22.74.74 0 00-.545.22.74.74 0 00-.22.546.74.74 0 00.22.545.74.74 0 00.545.22zm0-3.46c.202 0 .37-.069.506-.205a.687.687 0 00.204-.506v-4.263a.688.688 0 00-.204-.507.688.688 0 00-.506-.204.687.687 0 00-.506.204.688.688 0 00-.204.507v4.263c0 .201.068.37.204.506a.687.687 0 00.506.204zm.002 7.979a8.768 8.768 0 01-3.51-.709 9.091 9.091 0 01-2.859-1.923A9.09 9.09 0 015.71 17.51 8.76 8.76 0 015 14c0-1.244.236-2.414.709-3.51a9.09 9.09 0 011.923-2.858 9.09 9.09 0 012.857-1.924A8.76 8.76 0 0114 4.999c1.244 0 2.414.236 3.51.709a9.091 9.091 0 012.858 1.923 9.09 9.09 0 011.924 2.857 8.76 8.76 0 01.709 3.51 8.768 8.768 0 01-.709 3.51 9.092 9.092 0 01-1.923 2.858 9.09 9.09 0 01-2.857 1.924A8.76 8.76 0 0114 23zM14 21.578c2.116 0 3.908-.734 5.376-2.203 1.469-1.468 2.203-3.26 2.203-5.376 0-2.116-.734-3.908-2.203-5.376C17.908 7.154 16.116 6.42 14 6.42c-2.116 0-3.908.734-5.376 2.203-1.469 1.468-2.203 3.26-2.203 5.376 0 2.116.734 3.908 2.203 5.376 1.468 1.469 3.26 2.203 5.376 2.203z",
    fill: "#1C1B1F"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle-lime--error-85d97abc432ae7077a01064c45339c1d.svg";
export { SvgIconCircleLimeError as Component };